export default __webpack_public_path__ + "static/media/404.6e96ebbe.svg";